import getApiClient from '@/plugins/api'
import axios from 'axios'
import Vue from 'vue'

const moment = require('moment')

export default {
  loadProduct: function () {
    const self = this,
      api = getApiClient(self.$store),
      productId = self.$route.params.product

    self.$store.commit('startLoading')

    api.get(`boost_products/${productId}`)
      .then(response => {
        self.product = response.data

        if (self.product?.productionTime) {
          self.minDate = moment(self.minDate).add(self.product.productionTime, 'days').toDate()
        }
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })

  },

  customResultsDisplay: function (data) {
    return `${data.eventTitle} (${moment(data.startTime).format("DD/MM/YYYY")})`
  },

  deleteTrip: function (index) {
    Vue.set(this.trips, index, null)
  },

  addTrip: function () {
    Vue.set(this.trips, this.trips.length, {
      trip: '',
      title: '',
      interval: {},
      duration: 0,
    })
  },

  mapTrip: function (data, index) {
    this.trips[index].trip = data.value
    this.trips[index].title = data.display
  },

  nextStep: function () {
    this.step++
  },

  prevStep: function () {
    this.installments = null
    this.availableInstallments = []
    this.step--
  },

  setInstallments: function (value) {
    this.installments = value
  },

  loadAvailableInstallments: function () {
    const self = this,
      api = getApiClient(self.$store)

    self.$store.commit('startLoading')

    api.get(`cart/calculate_installments?price=${self.totalAmount}`)
      .then(result => {
        for (let installmentOption in result.data.installments) {
          const installment = result.data.installments[installmentOption],
            installmentAmount = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            }).format(installment.installment_amount),
            totalAmount = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            }).format(installment.amount),
            installmentObj = {
              label: `${installment.installment}x de ${installmentAmount} - Total de ${totalAmount}`,
              value: installment.installment,
              description: `Total de ${totalAmount}`,
              total: installment.amount
            }

          if (!self.installments) {
            self.installments = installmentObj.value
          }
          self.availableInstallments.push(installmentObj)
        }
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  updateInterval: function (index) {
    const interval = this.trips[index]?.interval
    this.selectingDate = null
    if (interval?.startDate && interval?.endDate) {
      const start = moment(interval.startDate)
      const end = moment(interval.endDate)
      this.trips[index].duration = end.diff(start, 'days') || 1
    }
  },

  updateMinDate: function (from) {
    let fromDate = moment(from)
    this.minDate = fromDate.add(7, 'days').toDate()
  },

  resetMinDate: function () {
    this.minDate = new Date()

    if (this.product?.productionTime) {
      this.minDate = moment(this.minDate).add(this.product.productionTime, 'days').toDate()
    }
  },

  createBoostPurchase: function () {
    const self = this,
      api = getApiClient(self.$store)

    return new Promise((resolve, reject) => {
      if (self.boost && self.boost['@id']) {
        resolve(self.boost)
      }

      self.$store.commit('startLoading')

      const tripIds = this.selectedTrips.map(trip => trip.trip)
      const tripIntervals = this.selectedTrips.map(trip => {
        return {
          trip: trip.trip,
          from: trip.interval.startDate,
          until: trip.interval.endDate
        }
      })

      api.post('/boosts', {
        type: 'featured',
        trips: tripIds,
        paymentMethod: self.paymentMethod,
        installments: self.installments,
        totalAmount: self.totalAmount,
        intervals: tripIntervals,
        product: self.product['@id'],
        quantity: self.boost.quantity
      })
        .then(result => {
          self.boost = result.data
          resolve(self.boost)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          self.$store.commit('stopLoading')
        })
    })
  },

  setPaymentMethod: function () {
    const self = this,
      api = getApiClient(self.$store)

    if (!self.boost || !self.boost['@id']) {
      return self.boost
    }

    self.$store.commit('startLoading')

    api.patch(self.boost['@id'], {
        paymentMethod: self.paymentMethod
      },
      {
        headers: {
          'Content-Type': 'application/merge-patch+json'
        }
      })
      .then(result => {
        self.boost = result.data
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  addToClipboard(value) {
    navigator.clipboard.writeText(value);

    this.pixCodeCopied = true
    window.setTimeout(() => {
      this.pixCodeCopied = false
    }, 2000)
  },


  createPixPayment: function () {
    const self = this

    self.$store.commit('startLoading')
    this.createCheckout()
      .then((result) => {
        this.pixData.qrCode = result.data.pix.qrCode
        this.pixData.code = result.data.pix.code

        this.checkPixStatus()
        this.$store.commit('stopLoading')

      })
      .catch(error => {
        self.$store.commit('stopLoading')
        if (error.response.status === 409) {
          self.checkPixStatus()
          return
        }
        self.showCheckoutError = true
      })
  },

  createCheckout: function () {
    const self = this,
      api = getApiClient(self.$store)

    let total = 0,
      card = {}

    if ((this.paymentMethod === 1 || !this.paymentMethod) && this.installments && this.availableInstallments) {
      total = this.availableInstallments[this.installments - 1].total

      card = {
        number: this.creditCardNumber.replace(/[^0-9]/g, ''),
        name: this.creditCardName,
        expiry_month: this.creditCardExpDate.slice(0, 2),
        expiry_year: this.creditCardExpDate.slice(5, 7),
        cvv: this.creditCardCode,
      }
    }

    if (this.paymentMethod === 3) {
      total = this.totalAmount
    }

    if (this.installments) {
      return new Promise((resolve, reject) => {
        {
          api.patch(`${this.boost['@id']}/create_checkout`, {
            checkoutAmount: total,
            paymentData: {
              installments: this.installments,
              payment_type: this.paymentMethod === 1 ? 'card' : 'pix',
              card
            }

          }, {
            headers: {
              'Content-Type': 'application/merge-patch+json'
            }
          })
            .then(result => {
              if (result.data.checkoutId) {
                this.checkoutId = result.data.checkoutId
                resolve(result)
              }
            })
            .catch(error => {
              reject(error)
            })
        }
      })
    }
  },

  cancelCheckPixStatus() {
    if (this.pixTimerId) {
      window.clearInterval(this.pixTimerId)
    }
  },

  checkPixStatus() {
    const api = getApiClient(this.$store)

    this.cancelCheckPixStatus()

    if (!this.boost || !this.boost['@id']) {
      return
    }
    this.pixTimerId = window.setInterval(() => {
      api.get(`${this.boost['@id']}/checkout_status`)
        .then(result => {
          if (result.data.status === 'PAID') {
            this.cancelCheckPixStatus()

            this.nextStep()
          }
        })
        .catch(() => {
        })
    }, 5000)
  },


  pay() {
    const api = getApiClient(this.$store)

    this.$store.commit('startLoading')
    this.createCheckout()
      .then((result) => {
        this.$store.commit('stopLoading')
        if (result.data.status === 'PAID') {
          api.patch(`${this.boost['@id']}/complete`, {}, {headers: {'Content-Type': 'application/merge-patch+json'}})
            .then(response => {
              if (response.data.status === 2) {
                this.nextStep()
              }
            })
            .catch(error => {
              console.log(error)
            })
        } else {
          this.invalidCardNumberMessage = 'Não foi possível realizar a cobrança com este cartão'
        }
      })
      .catch(error => {
        this.$store.commit('stopLoading')
        if (error.response.status === 400) {
          let data = error.response.data

          if (typeof data !== Array) {
            data = [data]
          }
          data.forEach(errorMessage => {
            switch (errorMessage.param) {
              case '$.card.number':
                this.invalidCardNumberMessage = 'Cartão inválido'
                break;
              case '$.card.name':
                this.invalidCardNumberMessage = 'Nome inválido'
                break;
              case '$.card.expiry_year':
              case '$.card.expiry_month':
                this.invalidCardExpDateMessage = 'Cartão expirado'
                break;
              case '$.card.cvv':
                this.invalidCardNumberMessage = 'CVV incorreto'
                break;
            }
          })
        } else {
          this.showCheckoutError = true
        }
      })
  },

  preloadTrip: function (tripId) {
    const api = getApiClient(this.$store)

    this.$store.commit('startLoading')
    api.get(`/trips/${tripId}`)
      .then(response => {
        const data = {
          display: `${response.data.eventTitle} (${moment(response.data.startTime).format("DD/MM/YYYY")})`,
          value: response.data['@id']
        }
        response.data.display = data.display
        response.data.value = data.value
        this.mapTrip(data, 0)
        this.preloadedTrip = response.data
        this.trips[0].title = `${response.data.eventTitle} (${moment(response.data.startTime).format("DD/MM/YYYY")})`
        this.trips[0].trip = `/trips/${tripId}`
      })
      .finally(() => {
        this.$store.commit('stopLoading')
      })
  }

}
